import { useContext } from 'react';
import { useStore } from 'zustand';
import { EntityStoreContext } from 'containers/pages/persons/store/EntityStoreContext';

export function useEntityContext(selector) {
  const store = useContext(EntityStoreContext);
  if (!store) throw new Error('Missing EntityStoreProvider in the tree');
  return useStore(store, selector);
}
